module.exports = __webpack_public_path__ + "img/support2.f794a2b8.jpg";